export const CANT_DELETE_BECAUSE_CONNECTIONS_KEY = 'connections';
export const CANT_DELETE_BECAUSE_CONNECTIONS_LOCATION = 'You have connections related to this app';
export const CANT_DELETE_BECAUSE_CONNECTIONS_MESSAGE = "Can't remove, because you have connections related to this app.";
export const CANT_DELETE_BECAUSE_SERVICE_WORKSPACE_KEY = 'appsWorkspace';
export const CANT_DELETE_BECAUSE_SERVICE_WORKSPACE_LOCATION = 'You have Add-ons in this app';
export const CANT_DELETE_BECAUSE_SERVICE_WORKSPACE_MESSAGE = "Can't remove, because you have an add-on button in this app.";

export const CANT_DELETE_APP_ERRORS = {
	[CANT_DELETE_BECAUSE_CONNECTIONS_KEY]: CANT_DELETE_BECAUSE_CONNECTIONS_MESSAGE,
	[CANT_DELETE_BECAUSE_SERVICE_WORKSPACE_KEY]: CANT_DELETE_BECAUSE_SERVICE_WORKSPACE_MESSAGE,
};
export const CANT_DELETE_APP_LOCATIONS = {
	[CANT_DELETE_BECAUSE_CONNECTIONS_KEY]: CANT_DELETE_BECAUSE_CONNECTIONS_LOCATION,
	[CANT_DELETE_BECAUSE_SERVICE_WORKSPACE_KEY]: CANT_DELETE_BECAUSE_SERVICE_WORKSPACE_LOCATION,
};

export const TRANSLATED_UNIDENTIFIED_SERVICE_WORKSPACE_ID = 'all';
export const TRANSLATED_UNIDENTIFIED_SERVICE_WORKSPACE_TITLE = 'Other workspaces';
export const UNIDENTIFIED_SERVICE_WORKSPACE_ID = 'unidentified';
export const UNIDENTIFIED_SERVICE_WORKSPACE_TITLE = 'Unidentified workspaces';
